"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
import { ExpandableListContainer, ExpandableListItem } from "./styles.js";
import { Button } from "../../Inputs/Button/index.js";
function ExpandableList({
  ariaLabeledById = "",
  buttonId,
  children,
  defaultItemsToExpose = 5,
  showMoreText
}) {
  const [itemsToExpose, setItemsToExpose] = useState(defaultItemsToExpose);
  const firstHiddenRef = useRef(null);
  useEffect(() => {
    var _a, _b, _c;
    if (itemsToExpose === children.length && itemsToExpose !== defaultItemsToExpose) {
      const inputs = (_a = firstHiddenRef.current) == null ? void 0 : _a.getElementsByTagName("input");
      const links = (_b = firstHiddenRef.current) == null ? void 0 : _b.getElementsByTagName("a");
      if (inputs && inputs.length > 0) {
        inputs[0].focus();
      } else if (links && links.length > 0) {
        links[0].focus();
      } else {
        (_c = firstHiddenRef.current) == null ? void 0 : _c.focus();
      }
    }
  }, [itemsToExpose, children.length, defaultItemsToExpose]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ExpandableListContainer, { "data-testid": "expandable-list", children: children.map((child, key) => /* @__PURE__ */ jsx(
      ExpandableListItem,
      {
        ref: key === defaultItemsToExpose ? firstHiddenRef : void 0,
        style: {
          display: key < itemsToExpose ? "block" : "none"
        },
        tabIndex: -1,
        children: child
      },
      key
    )) }),
    children.length > itemsToExpose && /* @__PURE__ */ jsx(
      Button,
      {
        id: buttonId,
        variant: "text-button",
        onClick: () => setItemsToExpose(children.length),
        "aria-labelledby": `${buttonId} ${ariaLabeledById}`,
        children: showMoreText
      }
    )
  ] });
}
export {
  ExpandableList
};
